import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetWorkstreams } from '../../redux/dataroomSlice';
import AiWardenModal from '../Dataroom2.0/AiWardenModal';

const AiWardenContext = createContext({
    openAiWarden: () => {},
});

export function useAiWarden() {
    return useContext(AiWardenContext);
}

const AiWardenProvider = ({ children }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { selectedProject } = useSelector(state => state?.projectData || {});
    const workstreams = useSelector(state => state?.dataroom?.workstreams || []);
    const projectId = selectedProject?.id;

    const openAiWarden = useCallback(() => {
        if (!projectId) return;
        setOpen(true);
    }, [projectId]);

    useEffect(() => {
        if (!open || !projectId) return;
        dispatch(GetWorkstreams(projectId));
    }, [open, projectId, dispatch]);

    const contextValue = useMemo(() => ({ openAiWarden }), [openAiWarden]);

    return (
        <AiWardenContext.Provider value={contextValue}>
            {children}
            {projectId ? (
                <AiWardenModal
                    open={open}
                    onOpenChange={setOpen}
                    projectId={projectId}
                    workstreams={workstreams}
                />
            ) : null}
        </AiWardenContext.Provider>
    );
};

export default AiWardenProvider;
